export default function agencyUniqueNameDirective(
  $q,
  amSharedModelService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const agencyId = attributes.agencyId || -1;
    ngModel.$asyncValidators.amAgencyUniqueName = modelValue => amSharedModelService
      .checkAgencyNameExists(agencyId, modelValue)
      .then((nameExists) => {
        if (!nameExists) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'amAgencyUniqueName';

agencyUniqueNameDirective.$inject = [
  '$q',
  'amSharedModelService',
];
